<ng-content></ng-content>
<div class="row">
    <div class="column">
        <app-select *ngIf="availableQualifications" [label]="firstLabel" [control]="selectedQualificationControl"
            data-test-id="qualificationSelect">
            <option hidden></option>
            <option *ngFor="let qual of availableQualifications" [value]="qual.code">{{qual.name}}</option>
        </app-select>
    </div>
    <div class="column" *ngIf="nextStep">
        <ng-container *ngIf="nextStepData$ | async as nextStepData; else loading">
            <app-select [label]="nextStep.label" [control]="nextStepControl" data-test-id="nextStepSelect"
                (valueChange)="setCategory($event, nextStepData)">
                <option hidden></option>
                <option *ngFor="let item of nextStepData" [value]="item.code">{{item.name}}</option>
            </app-select>
            <!-- loading spinner -->
        </ng-container>
    </div>
</div>

<app-form-group *ngIf="nextToNextStep">
    <app-select *ngIf="nextToNextStepData$ | async as nextToNextStepData; else loading" [label]="nextToNextStep.label"
        [control]="nextToNextStepControl" data-test-id="nextToNextStepSelect">
        <option hidden></option>
        <option *ngFor="let item of nextToNextStepData" [value]="item.code">{{item.name}}</option>
    </app-select>
</app-form-group>

<app-qualification-basis *ngIf="basisDef && basisArray" [availableBases]="basisDef" [selectedBases]="basisArray">
</app-qualification-basis>

<app-form-group>
    <button class="btn btn--secondary" [disabled]="!validationGroup.valid" (click)="addQualification()">Lägg
        till</button>
</app-form-group>

<span *ngIf="showWarning" class="text-error text-small ng-star-inserted">Ämnet kunde inte läggas till på grund av ett tekniskt fel. Vänligen välj ämnet igen och klicka på "Lägg till" på nytt.</span>

<app-view-qualifications *ngIf="qualifications" [qualifications]="qualifications"></app-view-qualifications>

<ng-template #loading>
    <div class="spinner-container">
        <mat-spinner diameter="74"></mat-spinner>
    </div>
</ng-template>